import clsx from 'clsx';
import PropTypes from 'prop-types';

export function MasterDetail({
  master,
  detail,
  hideOnMobile = true,
  sortOptions,
  onSortChange,
}) {
  /* Client component to render two children as a master-detail UI view pattern,
   * AKA a small left pane, contentful right pane situation.
   * By default, for now, hides master nav/left content on small screen widths via SCSS -
   * similar content can be provided by other means elsewhere in the DOM
   */
  return (
    <div className="master-detail">
      <div
        className={clsx(
          'master-detail__master',
          hideOnMobile && 'master-detail__master--hide-on-mobile',
        )}
      >
        {sortOptions && (
          <div className="master-detail__sort-options">
            <div className="searchspring-facet-filters__heading">Sort by:</div>
            <select
              className="searchspring-facet-filters__option"
              id="sortSelect"
              onChange={(e) => onSortChange(e.target.value)}
            >
              <option value="" disabled>
                Choose an option
              </option>
              {sortOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        )}
        {master}
      </div>
      <div className="master-detail__detail">{detail}</div>
    </div>
  );
}

MasterDetail.propTypes = {
  master: PropTypes.node,
  detail: PropTypes.node,
  hideOnMobile: PropTypes.bool,
  sortOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
  onSortChange: PropTypes.func,
};
